/* PATHOLOGISTS */
export const GET_ACTIVITY_LOG_MARKETER = "GET_ACTIVITY_LOG_MARKETER";
export const GET_ACTIVITY_LOG_MARKETER_SUCCESS = "GET_ACTIVITY_LOG_MARKETER_SUCCESS";
export const GET_ACTIVITY_LOG_MARKETER_FAIL = "GET_ACTIVITY_LOG_MARKETER_FAIL";

